import { QueryBuilderModel } from 'vet-bones/components';
import { MimeType } from 'vet-bones/constants';

import { RulesInfo } from 'src/containers/PublishProjectDrawer/types';
import { newline } from 'src/templates/copy';
import { ExportToFileOptions } from 'src/utils/exportToFile';
import { stringifyTurtleNamespaces } from 'src/utils/stringify/namespaces';
import { stringifyRules } from 'src/utils/stringify/rules/rules';
import { stringToFilename } from 'src/utils/stringToFilename';

export const exportRules = (
  name: string,
  model: QueryBuilderModel,
  ruleInfo: RulesInfo,
  databaseNamespaces: Record<string, string>
): ExportToFileOptions | null => {
  const rules = stringifyRules(model, ruleInfo, databaseNamespaces);
  if (!rules) {
    return null;
  }

  const filename = `${stringToFilename(name)}.srs`;
  const namespaces = stringifyTurtleNamespaces(databaseNamespaces);
  const contents =
    [namespaces, rules].filter((str) => str).join('\n\n') + newline;

  return { contents, filename, mimeType: MimeType.TURTLE };
};
